// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1krKQ","footer":"ModalError_footer__I4wA8"};